const galleryFr = {
    "file_upload_successful": "Téléchargement du fichier réussi",
    "file_upload_error": "Erreur lors du chargement du fichier",
    "attach_files": "Joindre des fichiers",
    "files_selected": "fichiers sélectionnés",
    "upload": "Télécharger",
    "uploading": "Téléchargement",
    "maximum_file_size": "La taille maximale autorisée pour les fichiers téléchargeables est de 10 Mo.",
    "download": "Télécharger",
    "open_in_new_tab": "Ouvrir dans un nouvel onglet",
    "delete_file": "Supprimer le fichier",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    "image_in_use": "L'image sélectionnée est utilisée dans les éléments de menu actifs suivants :",
    "image_in_use_tip": "Pour supprimer ce fichier, veuillez le retirer de toutes les annonces actives.",
    "file_deleted_successfully": "Fichier supprimé avec succès",
    "error_deleting_file": "Erreur lors de la suppression du fichier",
    "confirm_selection": "Confirmer la sélection",
    "file_deletion_forbidden": "Suppression de fichier interdite"
};

export default galleryFr;
